import { render, staticRenderFns } from "./warning-login.vue?vue&type=template&id=49e628c4&scoped=true"
import script from "./warning-login.vue?vue&type=script&lang=js"
export * from "./warning-login.vue?vue&type=script&lang=js"
import style0 from "./warning-login.vue?vue&type=style&index=0&id=49e628c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e628c4",
  null
  
)

export default component.exports